import React, {Component} from 'react';
import {Session, DeliveryDetailModel} from "../../components";
import {DISPATCH_ID, SERVICE_API, SERVICE_RESPONSE, VIEW_NAME, config} from "../../libs/utils/Const";
import {ApiClient} from "../../libs/apiClient/ApiClient";
import {connect} from "react-redux";
import moment from 'moment';
import $ from 'jquery';
import CurrencyFormat from 'react-currency-format';

const apiClient = ApiClient.getInstance();

require('datatables.net-bs4');

class deliveryViews extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            orders: [],
            order: {
                header: {},
                body: []
            },
            guia: []
        };
        this.table = null;
    }

    async componentDidMount() {
        this.createDataTable();
    }
    // Se llena la tabla con la configuración
    createDataTable = () => {
        this.table =  $('#tablaDelivery').DataTable({
                "paging": true,
                "info": false,
                "searching": false,
                //"bDestroy": true,	
                "order": [[ 0, 'desc' ]],
                "language": {
                    "lengthMenu": "Mostrar _MENU_ registros por página",
                    "zeroRecords": "No se encontraron registros",
                    "info": "Mostrando página _PAGE_ de _PAGES_",
                    "infoEmpty": "No existen registros",
                    "infoFiltered": "(filtrado de _MAX_ entradas)",
                    "loadingRecords": "Buscando...",
                    "processing": "Procesando...",
                    "search": "Buscar:",
                    "paginate": {
                        "first": "Primero",
                        "last": "Último",
                        "next": "Siguiente",
                        "previous": "Anterior"
                    }
                }
            });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.orders != nextProps.orders ||this.props.orders.length === 0 ) {
            this.table.destroy();
            this.table = null;
        }
        return true;
    }
    // se llena la tabla
    componentDidUpdate() {
        if (this.table == null) {
            this.createDataTable();
        }
    }

    openOrder = async docEntry => {
        const {enableSpinner, notificationReducer: {showAlert}} = this.props;
        enableSpinner(true);
        let response = await apiClient.getDataDelivery(docEntry);
        enableSpinner(false);

        if (response.status === SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                order: response.data,
                guia: response.data.statusGuia || [],
            });

            $('#deliveryModal').modal('show');
            return;
        }

        showAlert({type: 'error', message: response.message})
    };

    docChangeName(status){
        let result = '';
        switch (status) {
            case 'O':
                result = "Abierta";
                break;
            case 'C':
                result = "Cerrada";
                break;
            default:
                break;
        }
        return result;
    };

    BaseType = (baseType)=>{
        let result = '';
        switch (baseType) {
            case 17:
                result = "Pedido";
                break;
            case 15:
                result = "Entrega";
                break;
            default:
                break;
        }
        return result
    };

    docChangeNameFMB(target,base){
        let result = '';
        let response = target != -1 ? target : base
        
        switch (response) {
        //     case 23:
        //         result = "Sin atender";
        //         break;
        //     case 17:
        //         result = "Atendido";
        //         break;
            case 15:
                result = "Surtido";
                break;
            case 13:
                result = "Facturado";
                break;
            default:
                result = 'Surtido';
                break;
        }
        return result;
    };

    render() {
        const {order, guia} = this.state;
        const { orders,getData,handleInputDateInicio, handleInputDateFinal, fechaFinal,fechaInicio, fechamin, fechamax, isLoaded,configReducer:{currency}}  = this.props;
        return (
            <div className="content-fluid" style={{backgroundColor: config.Back.backgroundColor}}>
                <DeliveryDetailModel order={order} guia={guia}/>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16, color: config.reportViews.textColorW}}>
                    <div className="col-md-12 pb-2">
                        <h2>ENTREGAS</h2>
                    </div>
                </div>
                <div className="row text-center" style={{marginBottom: 16, marginTop: 16, color: config.reportViews.textColorW}}>
                    <div className=" row col-md-4">
                    <h4 className="pr-2">Desde:</h4>
                        <input 
                            id="fechaInicio"
                            type="date" 
                            className="form-control col-md-6" 
                            name="fechauno" 
                            min={fechamin}
                            max={fechamax}
                            value = {!isLoaded ? fechamin : fechaInicio}
                            onChange = {(event) => handleInputDateInicio(event)}/>
                    </div>
                    <div className="row col-md-4 pb-3" style={{color: config.reportViews.textColorW}}>
                        <h4 className="pr-2">Hasta:</h4>
                        <input 
                            id="FechaFin"
                            type="date" 
                            className="form-control col-md-6" 
                            name="fechados" 
                            min={fechamin}
                            max={fechamax}
                            value = {fechaFinal}
                            onChange = {(event) => handleInputDateFinal(event)}/>
                    </div>
                    <div className="col-md-2 pb-2">
                        <button
                            onClick={()=>getData(6)}
                            className="btn botonResumen" 
                            style={{
                                backgroundColor: config.navBar.menuCategoriesBackgroundHover,
                                color: 'white',
                                fontWeight: "bold",
                            }}>
                            Ver entregas
                        </button>
                    </div>
                </div>  
                <div ID="ItemsSlider" className="row">
                    <div className="col-md-12 table-responsive tableReports" style={{textAlign:"-webkit-center"}}>
                        <table id="tablaDelivery" className="table table-striped scrolltable" >
                            <thead>
                                <tr style={{backgroundColor: config.shoppingList.summaryList, color: config.shoppingList.textsummaryList, fontSize: config.reportViews.fontSize }}>
                                    <th scope="col-lg-2" >Fecha de creación</th>
                                    <th className="col-2">No. de entrega</th>
                                    {/* <th scope="col">Documento origen</th>
                                    <th scope="col">No. de relación</th> */} 
                                    <th scope="col-lg-3" >Estado</th>
                                    <th scope="col-lg-1" >Estado del pedido</th>
                                    <th scope="col-lg-3" >Valor total</th>
                                    <th scope="col-lg-2" ></th>
                                </tr>
                            </thead>
                            <tbody> 
                                {orders.map((order, index) => {
                                    return (<tr key={index} style={{ fontSize: config.reportViews.fontSize}}>
                                        <th scope="row" style={{width: '100px', maxWidth:'100px'}}>{moment(order.Fecha).utc().format('YYYY-MM-DD')}</th>
                                        <th style={{width: '100px', maxWidth:'100px'}}>{order.DocNum}</th>
                                        {/* <td>{this.BaseType(order.BaseType)}</td>
                                        <td>{order.BaseRef}</td> */}
                                        <td style={{width: '100px', maxWidth:'100px'}}>{this.docChangeName(order.DocStatus)}</td>
                                        <td className="col-lg-auto" style={{width: '250px'}}>{this.docChangeNameFMB(order.TargetType, order.BaseType)}</td>
                                        <td className="text-right" style={{width: '100px', maxWidth:'100px'}}>
                                            <CurrencyFormat 
                                                value={Number(order.Total)} 
                                                displayType={'text'} 
                                                thousandSeparator={'.'}
                                                decimalSeparator = {false}
                                                fixedDecimalScale={true} 
                                                decimalScale={0} 
                                                // prefix={currency.MainCurncy !== order.DocCur   ? '' : currency.DocCurrCod}
                                                prefix={'$ '}
                                                suffix = {' ' + currency.MainCurncy}>
                                            </CurrencyFormat>
                                        </td>
                                        <td style={{width: '100px', maxWidth:'100px'}}>
                                            <span onClick={() => this.openOrder(order.DocEntry)}>
                                                <i className={config.icons.detail} style={{color: config.shoppingList.summaryList, paddingRight: 6, fontSize: config.reportViews.fontSize}}></i>
                                                Detalle
                                            </span>
                                        </td>
                                    </tr>)
                                })}
                            </tbody>
                        </table>
                        
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        sessionReducer: store.SessionReducer,
        configReducer: store.ConfigReducer,
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({type: DISPATCH_ID.CONFIG_SET_SPINNER, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(deliveryViews);